const baseColorData = {};
const ColorData = {
  fromJSON(object) {
    const message = { ...baseColorData };
    message.background = object.background !== void 0 && object.background !== null ? String(object.background) : void 0;
    message.foreground = object.foreground !== void 0 && object.foreground !== null ? String(object.foreground) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.background !== void 0 && (obj.background = message.background);
    message.foreground !== void 0 && (obj.foreground = message.foreground);
    return obj;
  }
};
export {
  ColorData
};
//# sourceMappingURL=decoration_color.js.map
